var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-list"},[_c('el-dialog',{attrs:{"visible":_vm.showVideos,"title":_vm.$t('historyAlarm.label.uploadVideo'),"width":"460px"},on:{"update:visible":function($event){_vm.showVideos=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }